import { type IMediator } from '#/core/mediator';

import { SERVICES_TYPES } from '#/services-types';

import { type IDeviceService } from '../device';
import { type ILogService } from '../log';

import { type IVisibilityService } from './visibility.types';

export class VisibilityService implements IVisibilityService {
  readonly #serviceName = 'VisibilityService';

  get #deviceService() {
    return this._mediator.get<IDeviceService>(SERVICES_TYPES.DeviceService);
  }
  get #logService() {
    return this._mediator.get<ILogService>(SERVICES_TYPES.LogService);
  }

  constructor(private readonly _mediator: IMediator) {
    this.#logService.info(this.#serviceName, 'Instance was created.');

    if (this.#deviceService.parentApp) {
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          this.#logService.info(this.#serviceName, 'Document is visible.');

          if (!this.resetCache) {
            this.#logService.warn(this.#serviceName, 'Reset cache is not defined.');

            return;
          }

          if (!this.resetChartData) {
            this.#logService.warn(this.#serviceName, 'Reset chart data is not defined.');

            return;
          }

          // ? Order is important
          // eslint-disable-next-line max-len
          // https://www.tradingview.com/charting-library-docs/latest/api/interfaces/Charting_Library.IChartWidgetApi/#resetdata
          this.resetCache();
          this.resetChartData();

          this.#logService.info(
            this.#serviceName,
            'Reset cache and chart data success after document visibility change.'
          );
        }
      });
    }
  }

  resetCache: (() => void) | undefined;

  resetChartData: (() => void) | undefined;
}
